<template>
  <section class="page">
    <div class="container">
      <h3 class="title02 page__h2">エントリーシステム利用申請/設定</h3>
      <div class="box box--center mb-24">
        <p>{{ message }}</p>
      </div>
      <!-- {{ form_obj }} -->
      <div class="mb-40">
        <div class="mb-32" v-if="form_obj?.app_flg==1">
          <div></div>
          <div class="d-flex flex-column flex-md-row mt-32 justify-content-center column-gap-24">
            <button
              class="button03"
              @click="back"
            >
              <font-awesome-icon :icon="['fas', 'chevron-left']" class="mx-2" />
              <span class="button03__text">
                戻る
              </span>
            </button>
          </div>
        </div>
        <div class="mb-32" v-else>
          <div class="row gy-24">
            <div class="col-md-6">
              <h4 class="title08 d-block mb-24">基本情報</h4>
              <div class="page__inputGroupCol">
                <p class="page__inputGroupInner">
                  <span class="page__inputLabel page__inputGroupLabel">主催者名</span>
                  <input type="text" v-model="(form_obj || {}).COMPANY_NAME" :class="input_class(false)" :readonly="input_readonly(false)" />
                </p>
              </div>
              <div class="page__inputGroupCol" v-if="false">
                <p class="page__inputGroupInner">
                  <span class="page__inputLabel page__inputGroupLabel">主催者名正式</span>
                  <input type="text" v-model="(form_obj || {}).COMPANY_NAME_KAN" :class="input_class(false)" :readonly="input_readonly(false)" />
                </p>
              </div>
              <div class="page__inputGroupCol" v-if="false">
                <p class="page__inputGroupInner">
                  <span class="page__inputLabel page__inputGroupLabel">クラブメイト名</span>
                  <input type="text" v-model="(form_obj || {}).COMPANY_MEMBER_NAME" :class="input_class(false)" :readonly="input_readonly(false)" />
                </p>
              </div>
              <div class="page__inputGroupCol" v-if="false">
                <p class="page__inputGroupInner">
                  <span class="page__inputLabel page__inputGroupLabel">略称</span>
                  <input type="text" v-model="(form_obj || {}).COMPANY_MEMBER_NAME_RYAKU" :class="input_class(false)" :readonly="input_readonly(false)" />
                </p>
              </div>
              <div class="page__inputGroupCol">
                <p class="page__inputGroupInner">
                  <span class="page__inputLabel page__inputGroupLabel">電話番号</span>
                  <input type="text" v-model="(form_obj || {}).COMPANY_TEL" :class="input_class(false)" :readonly="input_readonly(false)" />
                </p>
              </div>
              <div class="page__inputGroupCol" v-if="false">
                <p class="page__inputGroupInner">
                  <span class="page__inputLabel page__inputGroupLabel">FAX番号</span>
                  <input type="text" v-model="(form_obj || {}).COMPANY_FAX" :class="input_class(false)" :readonly="input_readonly(false)" />
                </p>
              </div><div class="page__inputGroupCol">
                <p class="page__inputGroupInner">
                  <span class="page__inputLabel page__inputGroupLabel">郵便番号</span>
                  <input type="text" v-model="(form_obj || {}).COMPANY_YUUBIN" :class="input_class(false)" :readonly="input_readonly(false)" />
                </p>
              </div><div class="page__inputGroupCol">
                <p class="page__inputGroupInner">
                  <span class="page__inputLabel page__inputGroupLabel">住所</span>
                  <input type="text" v-model="(form_obj || {}).COMPANY_JUUSYO" :class="input_class(false)" :readonly="input_readonly(false)" />
                </p>
              </div>
              <div class="page__inputGroupCol" v-if="false">
                <p class="page__inputGroupInner">
                  <span class="page__inputLabel page__inputGroupLabel">営業日</span>
                  <input type="text" v-model="(form_obj || {}).COMPANY_EIGYOUBI" :class="input_class(false)" :readonly="input_readonly(false)" />
                </p>
              </div>
              <div class="page__inputGroupCol" v-if="false">
                <p class="page__inputGroupInner">
                  <span class="page__inputLabel page__inputGroupLabel">HPURL</span>
                  <input type="text" v-model="(form_obj || {}).COMPANY_HP_URL" :class="input_class(false)" :readonly="input_readonly(false)" />
                </p>
              </div>
              <div class="page__inputGroupCol">
                <p class="page__inputGroupInner">
                  <span class="page__inputLabel page__inputGroupLabel">代表メールアドレス</span>
                  <input type="text" v-model="(form_obj || {}).COMPANY_EMAIL" :class="input_class(false)" :readonly="input_readonly(false)" />
                </p>
              </div>
            </div>
            <div class="col-md-6 ">
              <h4 class="title08 d-block mb-24">エントリー決済情報</h4>
              <div class="page__inputGroupCol">
                <p class="page__inputGroupInner">
                  <span class="page__inputLabel page__inputGroupLabel">クレジット決済</span>
                  <input type="text" value="利用する" :class="input_class(false)" :readonly="input_readonly(false)" />
                </p>
              </div>
              <div class="page__inputGroupCol">
                <p class="page__inputGroupInner">
                  <span class="page__inputLabel page__inputGroupLabel">コンビニ決済</span>
                  <span
                    v-if="change_mode"
                    :class="input_class(false)"
                  >{{ get_list_label((form_obj || {}).CONVENI_KESSAI_FLG, list__CONVENI_KESSAI_FLG) }}</span>
                  <bs-select
                    v-else
                    :nullOption="true"
                    :options="list__CONVENI_KESSAI_FLG"
                    :value="(form_obj || {}).CONVENI_KESSAI_FLG"
                    v-model="(form_obj || {}).CONVENI_KESSAI_FLG"
                    :readonly="input_readonly(false)"
                  ></bs-select>
                </p>
              </div>

              <h4 class="title08 d-block mb-24">振込先情報</h4>
              <div class="page__inputGroup">
                <div class="page__inputGroupCol">
                  <p class="page__inputGroupInner">
                    <span class="page__inputLabel page__inputGroupLabel">銀行名</span>
                    <input type="text" v-model="(form_obj || {}).COMPANY_BANK_NAME" :class="input_class(true)" :readonly="input_readonly(true)" />
                  </p>
                </div>
                <div class="page__inputGroupCol">
                  <p class="page__inputGroupInner">
                    <span class="page__inputLabel page__inputGroupLabel">支店名</span>
                    <input type="text" v-model="(form_obj || {}).COMPANY_BANK_BRANCH_NAME" :class="input_class(true)" :readonly="input_readonly(true)" placeholder="" />
                  </p>
                  <span v-if="!change_mode" class="d-block text-end text-dark">ゆうちょ銀行の場合、店番を漢数字でご入力下さい</span>
                </div>
                <div class="page__inputGroupCol">
                  <p class="page__inputGroupInner">
                    <span class="page__inputLabel page__inputGroupLabel">口座種類</span>
                    <input type="text" v-model="(form_obj || {}).COMPANY_BANK_TYPE" :class="input_class(true)" :readonly="input_readonly(true)" placeholder="普通/当座/総合 等をご記入下さい"/>
                  </p>
                  <span v-if="!change_mode" class="d-block text-end text-dark">ゆうちょ銀行の場合、預金種目をご記入下さい</span>
                </div>
                <div class="page__inputGroupCol">
                  <p class="page__inputGroupInner">
                    <span class="page__inputLabel page__inputGroupLabel">口座番号</span>
                    <input type="text" v-model="(form_obj || {}).COMPANY_BANK_NUMBER" :class="input_class(true)" :readonly="input_readonly(true)" />
                  </p>
                </div>
                <div class="page__inputGroupCol">
                  <p class="page__inputGroupInner">
                    <span class="page__inputLabel page__inputGroupLabel">口座名義</span>
                    <input type="text" v-model="(form_obj || {}).COMPANY_BANK_ACCOUNT_NAME" :class="input_class(true)" :readonly="input_readonly(true)" />
                  </p>
                </div>
                <div class="page__inputGroupCol">
                  <p class="page__inputGroupInner">
                    <span class="page__inputLabel page__inputGroupLabel">口座名義(カタカナ)</span>
                    <input type="text" v-model="(form_obj || {}).COMPANY_BANK_ACCOUNT_NAME_KANA" :class="input_class(true)" :readonly="input_readonly(true)" />
                  </p>
                </div>
              </div>
              <div>
                <p>※ご送金は当月末締め、翌月10日お振込みになります。<br>(10日が休日の場合は休日明け扱い) </p>
              </div>
            </div>
            <div class="col-md-6" v-if="false">
              <h4 class="title08 d-block mb-24">エントリー</h4>
              <div class="page__inputGroup">
                <div class="page__inputGroupCol">
                  <p class="page__inputGroupInner">
                    <span class="page__inputLabel page__inputGroupLabel">受理書の送付方法</span>
                    <span
                      v-if="change_mode"
                      :class="input_class(false)"
                    >{{ get_list_label((form_obj || {}).RACE_ENTRY_ACCEPT_SEND_FLG, list__RACE_ENTRY_ACCEPT_SEND_FLG) }}</span>
                    <bs-select
                      v-else
                      :nullOption="true"
                      :options="list__RACE_ENTRY_ACCEPT_SEND_FLG"
                      :value="(form_obj || {}).RACE_ENTRY_ACCEPT_SEND_FLG"
                      v-model="(form_obj || {}).RACE_ENTRY_ACCEPT_SEND_FLG"
                      :readonly="input_readonly(false)"
                    ></bs-select>
                  </p>
                </div>
                <!-- CONVENI_KESSAI_FLG 上に移動-->
                <div class="page__inputGroupCol" v-if="(form_obj || {}).CONVENI_KESSAI_FLG==1">
                  <p class="page__inputGroupInner">
                    <span class="page__inputLabel page__inputGroupLabel">コンビニ決済通知アドレス(主)</span>
                    <input type="text" v-model="(form_obj || {}).COMPANY_MSEV_MEMBER_KESSAI_MAIL_LIST_TO" :class="input_class(false)" :readonly="input_readonly(false)" />
                  </p>
                </div>
                <div class="page__inputGroupCol" v-if="(form_obj || {}).CONVENI_KESSAI_FLG==1">
                  <p class="page__inputGroupInner">
                    <span class="page__inputLabel page__inputGroupLabel">コンビニ決済通知アドレス(CC)</span>
                    <input type="text" v-model="(form_obj || {}).COMPANY_MSEV_MEMBER_KESSAI_MAIL_LIST_CC" :class="input_class(false)" :readonly="input_readonly(false)" />
                  </p>
                </div>
                <div class="page__inputGroupCol" v-if="(form_obj || {}).CONVENI_KESSAI_FLG==1">
                  <p class="page__inputGroupInner">
                    <span class="page__inputLabel page__inputGroupLabel">コンビニ決済支払期限(エントリー日起算)</span>
                    <span
                      v-if="change_mode"
                      :class="input_class(false)"
                    >{{ get_list_label((form_obj || {}).COOMPANY_E_KESSAI_RACE_ENTRY_CONVENI_KIGEN_ENTRY_AFTER_DATE, list__DAY_NUM) }}</span>
                    <bs-select
                      v-else
                      :nullOption="true"
                      :options="list__DAY_NUM"
                      :value="(form_obj || {}).COOMPANY_E_KESSAI_RACE_ENTRY_CONVENI_KIGEN_ENTRY_AFTER_DATE"
                      v-model="(form_obj || {}).COOMPANY_E_KESSAI_RACE_ENTRY_CONVENI_KIGEN_ENTRY_AFTER_DATE"
                      :readonly="input_readonly(false)"
                    ></bs-select>
                  </p>
                </div>
                <div class="page__inputGroupCol" v-if="(form_obj || {}).CONVENI_KESSAI_FLG==1">
                  <p class="page__inputGroupInner">
                    <span class="page__inputLabel page__inputGroupLabel">コンビニ決済支払期限(締め切り日起算)</span>
                    <span
                      v-if="change_mode"
                      :class="input_class(false)"
                    >{{ get_list_label((form_obj || {}).E_KESSAI_RACE_ENTRY_CONVENI_KIGEN, list__DAY_NUM) }}</span>
                    <bs-select
                      v-else
                      :nullOption="true"
                      :options="list__DAY_NUM"
                      :value="(form_obj || {}).E_KESSAI_RACE_ENTRY_CONVENI_KIGEN"
                      v-model="(form_obj || {}).E_KESSAI_RACE_ENTRY_CONVENI_KIGEN"
                      :readonly="input_readonly(false)"
                    ></bs-select>
                  </p>
                </div>
                <div class="page__inputGroupCol">
                  <p class="page__inputGroupInner">
                    <span class="page__inputLabel page__inputGroupLabel">エントリー情報編集可否</span>
                    <span
                      v-if="change_mode"
                      :class="input_class(false)"
                    >{{ get_list_label((form_obj || {}).RACE_ENTRY_USER_EDIT_ON, list__OK_NG) }}</span>
                    <bs-select
                      v-else
                      :nullOption="true"
                      :options="list__OK_NG"
                      :value="(form_obj || {}).RACE_ENTRY_USER_EDIT_ON"
                      v-model="(form_obj || {}).RACE_ENTRY_USER_EDIT_ON"
                      :readonly="input_readonly(false)"
                    ></bs-select>
                  </p>
                </div>
                <div class="page__inputGroupCol">
                  <p class="page__inputGroupInner">
                    <span class="page__inputLabel page__inputGroupLabel">編集可能期限日数(レース開催日起算)</span>
                    <span
                      v-if="change_mode"
                      :class="input_class(false)"
                    >{{ get_list_label((form_obj || {}).COMPANY_RACE_EDIT_OK_DATE, list__DAY_NUM) }}</span>
                    <bs-select
                      v-else
                      :nullOption="true"
                      :options="list__DAY_NUM"
                      :value="(form_obj || {}).COMPANY_RACE_EDIT_OK_DATE"
                      v-model="(form_obj || {}).COMPANY_RACE_EDIT_OK_DATE"
                      :readonly="input_readonly(false)"
                    ></bs-select>
                  </p>
                </div>
                <div class="page__inputGroupCol">
                  <p class="page__inputGroupInner">
                    <span class="page__inputLabel page__inputGroupLabel">編集可能期限日数(エントリー終了日起算)</span>
                    <span
                      v-if="change_mode"
                      :class="input_class(false)"
                    >{{ get_list_label((form_obj || {}).COMPANY_RACE_EDIT_OK_ENTRY_DATE_AFTER, list__DAY_NUM) }}</span>
                    <bs-select
                      v-else
                      :nullOption="true"
                      :options="list__DAY_NUM"
                      :value="(form_obj || {}).COMPANY_RACE_EDIT_OK_ENTRY_DATE_AFTER"
                      v-model="(form_obj || {}).COMPANY_RACE_EDIT_OK_ENTRY_DATE_AFTER"
                      :readonly="input_readonly(false)"
                    ></bs-select>
                  </p>
                </div>
                <div class="page__inputGroupCol">
                  <p class="page__inputGroupInner">
                    <span class="page__inputLabel page__inputGroupLabel">エントリーキャンセル可否</span>
                    <span
                      v-if="change_mode"
                      :class="input_class(false)"
                    >{{ get_list_label((form_obj || {}).RACE_ENTRY_USER_CANCEL_ON, list__OK_NG) }}</span>
                    <bs-select
                      v-else
                      :nullOption="true"
                      :options="list__OK_NG"
                      :value="(form_obj || {}).RACE_ENTRY_USER_CANCEL_ON"
                      v-model="(form_obj || {}).RACE_ENTRY_USER_CANCEL_ON"
                      :readonly="input_readonly(false)"
                    ></bs-select>
                  </p>
                </div>
                <div class="page__inputGroupCol">
                  <p class="page__inputGroupInner">
                    <span class="page__inputLabel page__inputGroupLabel">キャンセル期限設定(レース開催日起算)</span>
                    <span
                      v-if="change_mode"
                      :class="input_class(false)"
                    >{{ get_list_label((form_obj || {}).COMPANY_RACE_CANCEL_OK_DATE, list__DAY_NUM) }}</span>
                    <bs-select
                      v-else
                      :nullOption="true"
                      :options="list__DAY_NUM"
                      :value="(form_obj || {}).COMPANY_RACE_CANCEL_OK_DATE"
                      v-model="(form_obj || {}).COMPANY_RACE_CANCEL_OK_DATE"
                      :readonly="input_readonly(false)"
                    ></bs-select>
                  </p>
                </div>
                <div class="page__inputGroupCol">
                  <p class="page__inputGroupInner">
                    <span class="page__inputLabel page__inputGroupLabel">キャンセル期限設定(エントリー締切日起算)</span>
                    <span
                      v-if="change_mode"
                      :class="input_class(false)"
                    >{{ get_list_label((form_obj || {}).COMPANY_RACE_CANCEL_OK_ENTRY_DATE_AFTER, list__DAY_NUM) }}</span>
                    <bs-select
                      v-else
                      :nullOption="true"
                      :options="list__DAY_NUM"
                      :value="(form_obj || {}).COMPANY_RACE_CANCEL_OK_ENTRY_DATE_AFTER"
                      v-model="(form_obj || {}).COMPANY_RACE_CANCEL_OK_ENTRY_DATE_AFTER"
                      :readonly="input_readonly(false)"
                    ></bs-select>
                  </p>
                </div>
              </div>
            </div>

            
          </div>

          <div class="d-flex flex-column flex-md-row mt-32 justify-content-center column-gap-24" v-if="form_obj.app_flg==0">
            <button
              class="button03"
              @click="back_input"
              v-if="change_mode"
            >
              <font-awesome-icon :icon="['fas', 'chevron-left']" class="mx-2" />
              <span class="button03__text">
                戻る
              </span>
            </button>
            <button
              class="button03"
              @click="back"
              v-else
            >
              <font-awesome-icon :icon="['fas', 'chevron-left']" class="mx-2" />
              <span class="button03__text">
                戻る
              </span>
            </button>

            <button
              v-if="change_mode && app_mode==0"
              type="button"
              @click="update"
              class="button04"
            >
              <span class="button04__text">
                申請する
              </span>
              <font-awesome-icon :icon="['fas', 'chevron-right']" class="mx-2" />
            </button>
            <button
              v-else-if="app_mode==0"
              type="button"
              @click="confirm_chk"
              class="button04"
            >
              <span class="button04__text">
                確認する
              </span>
              <font-awesome-icon :icon="['fas', 'chevron-right']" class="mx-2" />
            </button>
          </div>
          <div class="d-flex flex-column flex-md-row mt-32 justify-content-center column-gap-24" v-else>
            <button
              class="button03"
              @click="back"
            >
              <font-awesome-icon :icon="['fas', 'chevron-left']" class="mx-2" />
              <span class="button03__text">
                戻る
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
  .page__inputLabel {
    font-size: 0.9rem;
  }
  .input-group > .form-control-plaintext {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0;
    padding: 0.375rem;
    border-bottom: solid 1px #999;
  }
  .form-control-plaintext {
    border-bottom: solid 1px #999;
  }
</style>
<script>
  import { mapState } from 'vuex'
  // import BsPageTitle from '../../molecules/BsPageTitle.vue'
  // import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
  import BsSelect from '../../atoms/BsSelect.vue'
  // import BsCheckBox from '../../atoms/BsCheckBox.vue'
  // import '../../assets/bootstrap/css/sc.css';
  import config from '../../../const'

  export default {
    name: 'OwnerEntrySetting',
    data: function () {
      return {
        targetid: this.$store.state.oauth.userId,
        btnLabel: '',
        app_mode: 0,
        form_obj_tmp: {
          id: 0,
          stat: 0,
          app_flg: 0,
          COMPANY_BANK_NAME	:'',
          COMPANY_BANK_BRANCH_NAME	:'',
          COMPANY_BANK_TYPE	:'',
          COMPANY_BANK_NUMBER	:'',
          COMPANY_BANK_ACCOUNT_NAME	:'',
          COMPANY_BANK_ACCOUNT_NAME_KANA	:'',
          COMPANY_MSEV_MEMBER_KESSAI_MAIL_LIST_TO	:'',
          COMPANY_MSEV_MEMBER_KESSAI_MAIL_LIST_CC	:'',
          // コンビニ利用するか否か
          CONVENI_KESSAI_FLG: 0,
          COMPANY_E_KESSAI_KEY	:'',
          COMPANY_MEMBER_NAME	:'',
          COMPANY_MEMBER_NAME_RYAKU	:'',
          COMPANY_NAME_KAN	:'',
          COMPANY_NAME	:'',
          COMPANY_POST	:'',
          COMPANY_TEL	:'',
          COMPANY_FAX	:'',
          COMPANY_YUUBIN	:'',
          COMPANY_JUUSYO	:'',
          COMPANY_EIGYOUBI	:'',
          COMPANY_HP_URL	:'',
          COMPANY_EMAIL	:'',
          RACE_ENTRY_ACCEPT_SEND_FLG	:'',
          COOMPANY_E_KESSAI_RACE_ENTRY_CONVENI_KIGEN_ENTRY_AFTER_DATE	:'',
          E_KESSAI_RACE_ENTRY_CONVENI_KIGEN	:'',
          RACE_ENTRY_USER_EDIT_ON	:'',
          COMPANY_RACE_EDIT_OK_DATE	:'',
          COMPANY_RACE_EDIT_OK_ENTRY_DATE_AFTER	:'',
          RACE_ENTRY_USER_CANCEL_ON	:'',
          COMPANY_RACE_CANCEL_OK_DATE	:'',
          COMPANY_RACE_CANCEL_OK_ENTRY_DATE_AFTER	:'',
          
        },
        form_obj: {},
        data_obj: {},
        owner_obj: {},
        change_mode: false,
        message: 'エントリーシステムをご利用になる場合は申請を行ってください。',

        // form部品
        list__CONVENI_KESSAI_FLG: [
          {
            key: 0,
            label: '利用しない',
          },
          {
            key: 1,
            label: 'コンビニ決済を利用する',
          }
        ],
        list__RACE_ENTRY_ACCEPT_SEND_FLG: [
          {
            key: 0,
            label: '受理書をメールで受取る（マイページから受理書を印刷できます）',
          },
          {
            key: 1,
            label: '受理書を郵送で受取る',
          }
        ],
        list__OK_NG: [
          {
            key: 0,
            label: '拒否',
          },
          {
            key: 1,
            label: '許可',
          }
        ]
      }
    },
    components: {
      //   BsPageTitle,
        BsSelect,
      //   BsMsgAlert,
      // BsCheckBox,
    },
    methods: {
      async loadOwnerObj() {
        const params = {}
        params['stat'] = [1]
        params['id'] = this.$store.state.oauth.userId
        await this.basicPosts_S(config.BASE_API_URL + '/owner/lists', params)
          .then(async (response) => {
            console.log('loadOwnerObj', response)
            this.owner_obj =
              response.data && response.data.body && response.data.body[0]
                ? response.data.body[0]
                : {}
          })
          .catch(async (err) => {
            console.log(err)
            this.owner_obj = {}
          })
          .finally(async () => {
            this.$forceUpdate()
          })
      },
      async loadSettingObj() {
        const params = {}
        params['stat'] = [1]
        params['o_id'] = this.$store.state.oauth.userId
        await this.basicPosts_S(config.BASE_API_URL + '/entry_owner_setting/lists', params)
          .then(async (response) => {
            console.log('loadSettingObj', response)
            if(
              response?.data?.status == '200'
            ){
              this.data_obj =
              response.data && response.data.body && response.data.body[0]
                ? response.data.body[0]
                : {}
              this.form_obj = {...this.data_obj}
              if(
                this.data_obj?.app_flg == 0
              ){
                this.app_mode = 1
                this.message = '申請中です。'
                this.change_mode = true
              }
              this.app_mode = 10
            }else{
            this.data_obj = {}
            this.form_obj = {...this.form_obj_tmp}
            this.form_obj.COMPANY_NAME = (this?.owner_obj?.name_1)? this.owner_obj.name_1: ''
            this.form_obj.COMPANY_MEMBER_NAME_RYAKU = (this?.owner_obj?.name_1)? this.owner_obj.name_1: ''
            this.form_obj.COMPANY_NAME_KAN = (this?.owner_obj?.name_1)? this.owner_obj.name_1: ''
            this.form_obj.COMPANY_POST = (this?.owner_obj?.postal_cd)? this.owner_obj.postal_cd: ''
            this.form_obj.COMPANY_TEL = (this?.owner_obj?.tel_1)? this.owner_obj.tel_1: ''
            this.form_obj.COMPANY_FAX = (this?.owner_obj?.fax_1)? this.owner_obj.fax_1: ''
            this.form_obj.COMPANY_YUUBIN = (this?.owner_obj?.postal_cd)? this.owner_obj.postal_cd: ''
            const address_1 = (this?.owner_obj?.address_1)? this.owner_obj.address_1: ''
            const address_2 = (this?.owner_obj?.address_2)? this.owner_obj.address_2: ''
            this.form_obj.COMPANY_JUUSYO = address_1 + address_2
            this.form_obj.COMPANY_EMAIL = (this?.owner_obj?.mail_1)? this.owner_obj.mail_1: ''
          
            }
            
          })
          .catch(async (err) => {
            console.log(err)
            this.data_obj = {}
            this.form_obj = {...this.form_obj_tmp}
          })
          .finally(async () => {
            this.$forceUpdate()
          })
      },
      async confirm_chk() {
        if (this.change_login_id == '' || this.confirm_login_id == '') {
          alert('変更するログインIDを入力して下さい')
          return true
        } else if (
          this.change_login_id != '' &&
          this.confirm_login_id != '' &&
          this.change_login_id != this.confirm_login_id
        ) {
          alert('入力されたログインIDが一致しません')
          return true
        } else if (
          !/^[a-zA-Z0-9]{8,30}$/.test(
            this.change_login_id
          )
        ) {
          alert('ログインIDは8〜30文字の半角英数字を含む必要があります。')
          return true
        }
        let confirm_chk = true
        Object.keys(this.form_obj).forEach(form_key => {
          if(form_key != 'stat' && form_key != 'app_flg' && this.form_obj[form_key] == ''){
            // confirm_chk = false
            return
          }
        })
        if(confirm_chk){
          this.change_mode = true
        }else{
            alert('未設定項目があります')
        }
      },
      async update() {
        console.log('component methods', this.form_obj)
        const post_url = (this.form_obj?.id > 0)? '/entry_owner_setting/edit/' + this.form_obj?.id: '/entry_owner_setting/add'
        const params = {...this.form_obj}
        params.o_id = this.$store.state.oauth.userId
        let result = false
        await this.basicPosts_I(
          config.BASE_API_URL + post_url,
          params
        )
          .then(async (response) => {
            console.log('update', response)
            if (
              typeof response === 'object' &&
              typeof response.data === 'object' &&
              response.data.status == '200'
            ) {
              result = true
              this.message = '更新しました'
            } else {
              this.message = '更新できませんでした。'
            }
          })
          .catch(async (err) => {
            console.log(err)
            this.data_obj = []
            this.message = '更新できませんでした。'
          })
          .finally(async () => {
            if(result){
              await this.loadSettingObj()
            }

            this.$forceUpdate()
          })
      },
      back_input() {
        this.change_mode = false
      },
      back() {
        this.$router.go(-1)
      },
    },
    computed: {
      ...mapState({}),
      list__DAY_NUM: function(){
        const tmps = []
        for(let i=0;i<10;i++){
          tmps.push({
            key: i,
            label: i + '日'
          })
        }
        return [...tmps]
      },
      get_list_label: function () {
        return function (key, lists) {
          if (
            typeof lists === 'object' &&
            typeof lists.find((list) => list.key == key) === 'object'
          ) {
            return lists.find((list) => list.key == key).label
          }
          return key
        }
      },
      input_class: function () {
        const mode = this.change_mode
        return function(form_sw){
          if(form_sw){
            if (mode) {
              return 'form-control-plaintext'
            } else {
              return 'form-control'
            }
          }
          return 'form-control-plaintext'
        }
      },
      input_readonly: function () {
        const mode = this.change_mode
        return function(form_sw){
          if(form_sw){
            if (mode) {
              return true
            } else {
              return false
            }
          }
          return true
        }
        // if (this.change_mode) {
        //   return true
        // } else {
        //   return false
        // }
      },
    },

    async created() {
      await this.loadOwnerObj()
      await this.loadSettingObj()
    },
    mounted: function () {
      // console.log('tags_list', this.tags_list);
    },
    props: {},
  }
</script>
